import * as THREE from "three";
import gsap from 'gsap';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import Experience from './Experience.js';

export default class Camera{
  constructor(){
    this.experience = new Experience();
    this.world = this.experience.world;
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.canvas = this.experience.canvas;
    this.debug = this.experience.debug;
    this.resources = this.experience.resources;

    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    this.lastClickedPoint = null

    this.setInstence();
    // this.setControls();
    this.addEventListeners();

    this.loadingKnapp = document.getElementById("loading-knapp");

    if(this.debug.active){
      this.debugFolder = this.debug.ui.addFolder('Kamera');
    }

    const musikk = this.instance;
    this.loadingKnapp?.addEventListener("click", function () {
      const listener = new THREE.AudioListener();
      musikk.add(listener);
      const sound = new THREE.Audio(listener);
      const audioLoader = new THREE.AudioLoader();
      audioLoader.load("models/Kassert/Cornfield-chase.mp3", function (buffer) {
        sound.setBuffer(buffer);
        sound.setLoop(true);
        sound.setVolume(0.5);
        // sound.play();
      });
    });

  
  }

  addEventListeners() {
    window.addEventListener('dblclick', (event) => this.onMouseClick(event));
  }

  onMouseClick(event) {
    this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
    this.mouse.y = -(event.clientY / this.sizes.height) * 2 + 1;
    this.raycaster.setFromCamera(this.mouse, this.instance);
    const intersects = this.raycaster.intersectObjects(this.scene.children, true);
    if (intersects.length > 0) {
      const point = intersects[0].point;
      this.lastClickedPoint = point.clone()
      console.log(`Klikk posisjon: x=${point.x.toFixed(2)}, ${point.y.toFixed(2)}, ${point.z.toFixed(2)}`);
      const marker = new THREE.Mesh(
        new THREE.SphereGeometry(0.01, 16, 16),
        new THREE.MeshBasicMaterial({ color: 0xff0000 })
      );
      marker.position.copy(point);
      this.scene.add(marker);
    }
  }

  rotateCamera(x, y, z, duration){
    gsap.to(this.instance.rotation,{ x, y, z, duration });
  }

  setInstence() {
    this.instance = new THREE.PerspectiveCamera(
      35,
      this.sizes.width / this.sizes.height,
      0.1,
      500           // <--- outdoorFar i kontrolleren matcher dette
    );
    // this.instance.position.set(0.9, 0.5, 4.5);
    this.instance.position.set(4.3, 2.17, 80.65);
    this.instance.rotation.set(-2.2, -0.8, -2.3);
    
    this.scene.add(this.instance);
  }

  setControls() {
    this.controls = new OrbitControls(this.instance, this.canvas);
    this.controls.enableDamping = false;
    this.controls.target.set(4.5, 2.17, 81)
    this.controls.update();
  }

  resize(){
    this.instance.aspect = this.sizes.width / this.sizes.height;
    this.instance.updateProjectionMatrix();
  }

  update(){
    // this.controls.update();
    // console.log(this.instance.position)
    // console.log(this.instance.rotation)
  }
}